module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "winner",
    staticClass: "winner"
  }, [_c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('tr', {
      key: item.number
    }, [_c('td', [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.tel))])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Ngày quay\t")]), _vm._v(" "), _c('th', [_vm._v("Mã trúng thưởng\t")]), _vm._v(" "), _c('th', [_vm._v("Di động")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9511076a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Winner.vue
// module id = 1000
// module chunks = 1